module.exports = __webpack_public_path__ + "img/ScanButton.2a86ceda.svg";